// Free tier limits
export const FREE_LIMITS = {
  AI_WORKOUTS_PER_WEEK: 3,
  MAX_SAVED_WORKOUTS: 3,
  MAX_SAVED_EXERCISES: 10,
  AI_REFINEMENTS_PER_WEEK: 1,
  MAX_PROGRESS_PHOTOS: 10,
  MAX_CUSTOM_EXERCISES: 5,
};
